import { replaceUrlPlaceholders } from "react-utils";
import axiosCoralie from "../axios-setup";

const CONF = window?.confPub;
const DOCUMENTS_GRC_EVT_ROUTES = CONF?.ROUTES?.DOCUMENTS_GRC_EVT

export const getCarteTp = async (numContrat) => {

    const GET_CARTE_TP = DOCUMENTS_GRC_EVT_ROUTES?.GET_CARTE_TP

    const urlWithNumContrat = replaceUrlPlaceholders(GET_CARTE_TP,
        { numContrat: numContrat })

    try {

        const resp = await axiosCoralie.get(urlWithNumContrat)

        if (resp?.data?.code) {

            throw new Error("Echec de l'envoi de pièce jointe")
        } else {

            return resp?.data
        }

    } catch (err) {
        console.log("err", err)
        throw err;
    }
}

export const getDocumentSinistre = async (numContrat, numSinistre) => {

    const GET_DOCUMENT_SINISTRE = DOCUMENTS_GRC_EVT_ROUTES?.GET_DOCUMENT_SINISTRE

    const urlWithNumContratNumSinistre = replaceUrlPlaceholders(GET_DOCUMENT_SINISTRE,
        { numContrat: numContrat, numSinistre: numSinistre })

    try {

        const resp = await axiosCoralie.get(urlWithNumContratNumSinistre)

        if (resp?.data?.code) {

            throw new Error("Echec de lors de la récupération du document sinistre")
        } else {

            console.log("resp")
            console.log(resp)

            return resp?.data
        }

    } catch (err) {
        console.log("err", err)
        throw err;
    }
}

export const getDocumentsTicDoc = async (numContrat) => {

    const GET_DOCUMENT_TIC_DOC = DOCUMENTS_GRC_EVT_ROUTES?.GET_DOCUMENT_TIC_DOC

    const urlWithNumContratNumSinistre = replaceUrlPlaceholders(GET_DOCUMENT_TIC_DOC,
        { numContrat: numContrat })

    try {

        const resp = await axiosCoralie.get(urlWithNumContratNumSinistre)

        if (resp?.data?.code) {

            throw new Error("Echec lors de la récupération des lien TicDoc")
        } else {

            console.log("resp")
            console.log(resp)

            return resp?.data
        }

    } catch (err) {
        console.log("err", err)
        throw err;
    }
}

export const getPdfBase64 = async (lien) => {

    const GET_PDF_BASE64 = DOCUMENTS_GRC_EVT_ROUTES?.GET_PDF_BASE64

    const urlWithlien = replaceUrlPlaceholders(GET_PDF_BASE64,
        { lien: lien })

    try {

        const resp = await axiosCoralie.get(urlWithlien)

        if (resp?.data?.code) {

            throw new Error("Echec de l'envoi de pièce jointe")
        } else {

            console.log("resp")
            console.log(resp)

            return resp?.data
        }

    } catch (err) {
        console.log("err", err)
        throw err;
    }
}